export const level = ['STANDARD', 'ADVANCED'];
export const LevelEnum = {
    STANDARD: 'Standard',
    ADVANCED: 'Avancé',
};
